"use client";

import { Link } from "lucide-react";
import { motion } from "framer-motion";

function slugify(text: string) {
  return text.toLowerCase().replace(/\s+/g, "-");
}

export default function BlogContent({ content }: any) {
  return (
    <article className="max-w-3xl mx-auto text-gray-800 leading-relaxed">

      {content.map((block: any, i: number) => {
        /* ---------------- HEADING ---------------- */

        if (block.type === "heading") {
          const id = slugify(block.text);

          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="group relative mt-16 first:mt-0"
            >
              <h2
                id={id}
                className="scroll-mt-32 text-3xl font-bold text-gray-900 flex items-center gap-3"
              >
                {block.text}

                {/* Anchor link */}
                <a
                  href={`#${id}`}
                  className="opacity-0 group-hover:opacity-100 transition"
                >
                  <Link size={18} className="text-emerald-600" />
                </a>
              </h2>

              {/* section divider */}
              <div className="mt-4 h-[2px] w-16 bg-emerald-500 rounded-full"></div>
            </motion.div>
          );
        }

        /* ---------------- PARAGRAPH ---------------- */

        if (block.type === "paragraph") {
          return (
            <motion.p
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="mt-6 text-lg leading-8 text-gray-700"
            >
              {block.text}
            </motion.p>
          );
        }

        /* ---------------- LIST ---------------- */

        if (block.type === "list") {
          return (
            <motion.ul
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="mt-6 space-y-4"
            >
              {block.items.map((item: string, j: number) => (
                <li
                  key={j}
                  className="flex items-start gap-3 text-gray-700 text-lg"
                >
                  <span className="mt-2 h-2 w-2 rounded-full bg-emerald-500"></span>
                  <span>{item}</span>
                </li>
              ))}
            </motion.ul>
          );
        }

        return null;
      })}
    </article>
  );
}